import { render } from "./Verify.vue?vue&type=template&id=47260164"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__